// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-containers-Assets-AssetDetail-Discussions-___Messages-module__dateSeparator {
  margin: 20px auto 10px auto;
  padding: 2px 5px;
  border-radius: 3px;
  color: grey;
  font-size: 12px;
  background-color: rgba(0, 0, 0, 0.05);
}

.app-containers-Assets-AssetDetail-Discussions-___Messages-module__postsContainer {
  width: 100%;
  padding: 0px 20px 10px 0px;
}

.app-containers-Assets-AssetDetail-Discussions-___Messages-module__postContainer {
  transition: all 1000ms;
  width: 100%;
  overflow-x: auto;
}
.app-containers-Assets-AssetDetail-Discussions-___Messages-module__postContainer:hover .app-containers-Assets-AssetDetail-Discussions-___Messages-module__postActions {
  opacity: 1;
}

.app-containers-Assets-AssetDetail-Discussions-___Messages-module__postActions {
  opacity: 0;
  margin-left: 10px;
}
.app-containers-Assets-AssetDetail-Discussions-___Messages-module__postAction {
  color: lightgrey;
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.app-containers-Assets-AssetDetail-Discussions-___Messages-module__postAction:hover {
  color: grey;
}

.app-containers-Assets-AssetDetail-Discussions-___Messages-module__post {
  background-color: rgba(0, 0, 0, 0.03);
  padding: 12px;
  border-radius: 5px;
  margin-bottom: 2px;
}

.app-containers-Assets-AssetDetail-Discussions-___Messages-module__postHighlighted {
  background-color: rgba(0, 0, 200, 0.05);
  padding: 5px;
  margin: 5px 0;
  border-radius: 5px;
}

.app-containers-Assets-AssetDetail-Discussions-___Messages-module__logo {
  margin: 0 10px 10px 10px !important;
}

.app-containers-Assets-AssetDetail-Discussions-___Messages-module__logoThumbnail {
  margin: 0 10px 10px 10px !important;
  width: 42px;
  height: 40px;
  border-radius: 3px;
}

.app-containers-Assets-AssetDetail-Discussions-___Messages-module__editorRead {
  font-family: 'Helvetica Neue', 'Segoe UI', Helvetica, Arial, sans-serif;
}

.app-containers-Assets-AssetDetail-Discussions-___Messages-module__editorRead figure {
    max-width: 300px;
  }

.app-containers-Assets-AssetDetail-Discussions-___Messages-module__unreadContainer {
  width: 100%;
  margin: 25px 0 15px 0;
  position: relative;
  height: 2px;
  background-color: lightgrey;
  display: flex;
  justify-content: center;
}
.app-containers-Assets-AssetDetail-Discussions-___Messages-module__unreadLabel {
  position: absolute;
  top: -9px;
  margin: 0 auto;
  background-color: lightgrey;
  padding: 0px 10px;
  border-radius: 3px;
  color: grey;
  font-size: 12px;
  line-height: 20px;
  max-height: 20px;
}

.app-containers-Assets-AssetDetail-Discussions-___Messages-module__usernameContainer {
  word-break: break-word;
  font-size: 12px;
  color: grey;
  width: 90px;
  text-transform: capitalize;
  text-align: center;
}
.app-containers-Assets-AssetDetail-Discussions-___Messages-module__username {
  width: 90px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./app/containers/Assets/AssetDetail/Discussions/Messages.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uEAAuE;AAIzE;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".dateSeparator {\n  margin: 20px auto 10px auto;\n  padding: 2px 5px;\n  border-radius: 3px;\n  color: grey;\n  font-size: 12px;\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.postsContainer {\n  width: 100%;\n  padding: 0px 20px 10px 0px;\n}\n\n.postContainer {\n  transition: all 1000ms;\n  width: 100%;\n  overflow-x: auto;\n}\n.postContainer:hover .postActions {\n  opacity: 1;\n}\n\n.postActions {\n  opacity: 0;\n  margin-left: 10px;\n}\n.postAction {\n  color: lightgrey;\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n\n.postAction:hover {\n  color: grey;\n}\n\n.post {\n  background-color: rgba(0, 0, 0, 0.03);\n  padding: 12px;\n  border-radius: 5px;\n  margin-bottom: 2px;\n}\n\n.postHighlighted {\n  background-color: rgba(0, 0, 200, 0.05);\n  padding: 5px;\n  margin: 5px 0;\n  border-radius: 5px;\n}\n\n.logo {\n  margin: 0 10px 10px 10px !important;\n}\n\n.logoThumbnail {\n  margin: 0 10px 10px 10px !important;\n  width: 42px;\n  height: 40px;\n  border-radius: 3px;\n}\n\n.editorRead {\n  font-family: 'Helvetica Neue', 'Segoe UI', Helvetica, Arial, sans-serif;\n  figure {\n    max-width: 300px;\n  }\n}\n\n.unreadContainer {\n  width: 100%;\n  margin: 25px 0 15px 0;\n  position: relative;\n  height: 2px;\n  background-color: lightgrey;\n  display: flex;\n  justify-content: center;\n}\n.unreadLabel {\n  position: absolute;\n  top: -9px;\n  margin: 0 auto;\n  background-color: lightgrey;\n  padding: 0px 10px;\n  border-radius: 3px;\n  color: grey;\n  font-size: 12px;\n  line-height: 20px;\n  max-height: 20px;\n}\n\n.usernameContainer {\n  word-break: break-word;\n  font-size: 12px;\n  color: grey;\n  width: 90px;\n  text-transform: capitalize;\n  text-align: center;\n}\n.username {\n  width: 90px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dateSeparator": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__dateSeparator`,
	"postsContainer": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__postsContainer`,
	"postContainer": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__postContainer`,
	"postActions": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__postActions`,
	"postAction": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__postAction`,
	"post": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__post`,
	"postHighlighted": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__postHighlighted`,
	"logo": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__logo`,
	"logoThumbnail": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__logoThumbnail`,
	"editorRead": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__editorRead`,
	"unreadContainer": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__unreadContainer`,
	"unreadLabel": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__unreadLabel`,
	"usernameContainer": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__usernameContainer`,
	"username": `app-containers-Assets-AssetDetail-Discussions-___Messages-module__username`
};
export default ___CSS_LOADER_EXPORT___;
